import * as React from "react";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _Alarmclock(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return React.createElement("span", { className: classes, ref: ref, ...rest },
        React.createElement("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24" },
            React.createElement("circle", { cx: 12, cy: 13, r: 7, stroke: "currentColor", strokeWidth: 2 }),
            React.createElement("path", { stroke: "currentColor", strokeLinecap: "round", strokeWidth: 2, d: "M5 5 3 7M19 5l2 2M9 11l2.81 1.873a.25.25 0 0 0 .333-.052L14 10.5" })));
}
const Alarmclock = forwardRef(_Alarmclock);
export { Alarmclock };
